<!--
 * @Author: your name
 * @Date: 2020-04-17 15:45:43
 * @LastEditTime: 2020-04-30 16:48:46
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \musicshop_resource\src\App.vue
 -->
<template>
  <div id="app">
    <transition 
      name="fade" 
      mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {}
};
</script>

<style lang="scss">
body {
  margin: 0px;
  padding: 0px;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB,
    Microsoft YaHei, SimSun, sans-serif;
  font-size: 14px;
  -webkit-font-smoothing: antialiased;
}

#app {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
}

.el-submenu [class^='fa'] {
  vertical-align: baseline;
  margin-right: 10px;
}

.el-menu-item [class^='fa'] {
  vertical-align: baseline;
  margin-right: 10px;
}

.toolbar {
  background: #f2f2f2;
  padding: 10px;
  margin: 10px 0px;
  .el-form-item {
    margin-bottom: 10px;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.ant-pagination-item-active {
  background: #f6d85a;
  border-color: #f6d85a;
  color: black;
}
.ant-pagination-item-active:focus,
.ant-pagination-item-active:hover,
.ant-pagination-item:focus,
.ant-pagination-item:hover {
  color: black;
  border-color: #f6d85a;
  a {
    color: #000;
  }
}
.ant-pagination-item-active {
  color: black;
  border-color: #f6d85a !important;
}
.ant-pagination-item-active a {
  color: black;
  border-color: #f6d85a !important;
}
.table-filename {
  display: flex;
  font-weight: 400;
  line-height: 38px;
  margin-bottom: 3px;
  height: 38px;
  width: 200px;
}
.table {
  .ant-table-thead th,
  .ant-table-tbody td {
    padding: 16px 5px;
  }
  .music_title {
    display: block;
    font-size: 14px;
    overflow: hidden;
    word-break: break-all;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    display: -webkit-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue